import { render } from "./SSWTryeRangeView.vue?vue&type=template&id=5dad22cc&ts=true"
import script from "./SSWTryeRangeView.vue?vue&type=script&lang=ts"
export * from "./SSWTryeRangeView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__